import { gsap } from "gsap";
import { CSSRulePlugin } from "gsap/CSSRulePlugin";
import { EaselPlugin } from "gsap/EaselPlugin";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {scrollTo, randomic, ismobile} from "../libs/utils";
import * as Header from './header.js';

gsap.registerPlugin(CSSRulePlugin, EaselPlugin, ScrollToPlugin, ScrollTrigger);

function searchForArticle(){
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('articolo');
}

function progress(){
  let tl = gsap.timeline();
  
  tl.to('.progress-bar', {width: '50%', duration: 0.5 ,ease:'linear'});
  tl.to('.ramon',{left: '50%', duration: '0.5', delay:0.5, ease:'linear'}, "-=0.5");
  tl.to('.progress-bar', {width: '100%',  duration: 0.5,ease:'linear'})
  tl.to('.ramon', {left: '100%', delay:3.1, duration:0.8, ease:'linear', onComplete: function(){

    gsap.to('.credits', {y:-50, opacity:0,duration:0.2})
    gsap.to('.progress-bar', {opacity:0, duration:0.2})
    gsap.to('.ramon', {x:'200%', opacity:0, duration:0.2, delay:0.2, ease: "back.in(1.5)", onComplete: function(){

      showContent();
    }})
    
  }}, "-=3.2")
 
}

function showContent(){
  gsap.to(".overloading", {opacity:0, onComplete: function(){
    $('.overloading').remove();

    Header.startHeader(ismobile());
   
  }})
}

export function init(){

  let articleID = searchForArticle();

    if (articleID) {

      let h = 0
      let hTemp = $('#articolo-'+articleID).offset();
      h = hTemp.top; 

      scrollTo(h,null, progress);
  
    } else {

      progress();
      
    }
}

export function menuScrollToggle(){
  
  gsap.timeline({
    scrollTrigger: {
      trigger: '.header-box',
      start: "bottom 50%",
      toggleActions: "play none none reverse",
    }
  })
  .to('.menu', {right: "8px",  ease: "linear"},)
    
}

export function general(){
        let offset = 0;
        let offsetPopIn = 0;
      
        if (ismobile){
          offset = 16
          let offsetPopIn = 25;
        }

        gsap.utils.toArray(".anim-popup").forEach(box => {
            gsap.timeline({
              scrollTrigger: {
                trigger: box,
                start: "top bottom",
                toggleActions: "play none none reverse",
              }
            })
            .fromTo(box, {opacity: 0, y:50}, {opacity:1, y:0, duration: 0.3,  ease: "ease"})
        });

        gsap.utils.toArray('.anim-rightin').forEach(box => {
          gsap.timeline({
              scrollTrigger: {
                trigger: box,
                start: "top 70%",
                toggleActions: "play none none reverse",
              }
            })
            .fromTo(box, {opacity: 0, y:100}, {opacity:1, y:0, duration: 0.3,  ease: "ease", stagger:0.2})
        });

        gsap.utils.toArray('.anim-leftin').forEach(box => {
          gsap.timeline({
            scrollTrigger: {
              trigger: box,
              start: "top 70%",
              toggleActions: "play none none reverse",
            }
          })
          .fromTo(box, {opacity: 0, y:100}, {opacity:1, y:0, duration: 0.3,  ease: "ease", stagger:0.2})
        });

        gsap.utils.toArray(".anim-rotatein").forEach(box => {
          gsap.timeline({
            scrollTrigger: {
            trigger: box,
            start: `top ${70 + offset}%`,
            toggleActions: "play none none reverse",
            }
          }).from(box, {scale: 0.3, rotation:45, autoAlpha: 0,  ease: "power2"})
        });

        gsap.utils.toArray(".anim-etichetta").forEach(box => {
          gsap.timeline({
            scrollTrigger: {
            trigger: box,
            start: `top ${70 + offset}%`,
            scrub: true,
            toggleActions: "play none none reverse",
            }
            }).from(box, {x:'-30%', ease: "linear"})
        });

        gsap.utils.toArray('.anim-sharein a').forEach(box => {
          gsap.timeline({
            scrollTrigger: {
              trigger: box,
              start: `top ${70 + offset}%`,
              toggleActions: "play none none reverse",
            }
          })
          .fromTo(box, {opacity: 0, y:100}, {opacity:1, y:0, duration: 0.3,  ease: "ease", stagger:0.2})
        });

        gsap.utils.toArray('.anim-imageleft').forEach(box => {
          gsap.timeline({
            scrollTrigger: {
              trigger: box,
              start: "top 50%",
              toggleActions: "play none none reverse",
            }
          })
          .fromTo(box, {opacity: 0, y:100}, {opacity:1, y:0})
        });

        gsap.utils.toArray('.anim-imageright').forEach(box => {
          gsap.timeline({
            scrollTrigger: {
              trigger: box,
              start: "top 50%",
              toggleActions: "play none none reverse",
            }
          })
          .fromTo(box, {opacity: 0, y:100}, {opacity:1, y:0 })
        });

        gsap.utils.toArray('.anim-scaling').forEach(box => {
          gsap.timeline({
            scrollTrigger: {
              trigger: box,
              start: "top 90%",
              toggleActions: "play none none reverse",
            }
          })
          .to(box, {scale: 1, ease: "bounce.out", duration:0.8} )
        });

        gsap.utils.toArray(".anim-fadein").forEach(box => {

          gsap.set(box, {
            opacity:0
          })

          gsap.timeline({
            scrollTrigger: {
              trigger: box,
              start: `top ${70 + offset}%`,
              end: "top center",
              toggleActions: "play none none reverse",
            }
          })
          .fromTo(box, {opacity: 0}, {opacity:1, duration: 0.3,  ease: "ease", stagger:0.2})
        });

        gsap.utils.toArray(".anim-slideinright").forEach(box => {
          gsap.timeline({
            scrollTrigger: {
            trigger: box,
            start: `top ${70 + offset}%`,
            end: `top 40%`,
            scrub: true,
            toggleActions: "play none none reverse",
            }
          }).from(box, {x:500, opacity:0, duration:0.8, ease: "power2.out"})
        })

        gsap.utils.toArray(".anim-slideinleft").forEach(box => {
          gsap.timeline({
            scrollTrigger: {
            trigger: box,
            start: `top ${70 + offset}%`,
            scrub: true,
            end: `top 40%`,
            toggleActions: "play none none reverse",
            }
          }).from(box, {x:-400, opacity:0, duration:0.8, ease: "power2.out"})
        })


       


        gsap.set('.box2',{
          y: 100,
          opacity:0
        });
        gsap.timeline({
          scrollTrigger: {
          trigger: '.box2',
          start: `top ${70 + offset}%`,
     
          toggleActions: "play none none reverse",
          }
        }).to('.box2', {y:0 ,opacity: 1, duration:1, ease: "power2.out"})



      

        gsap.set('.papel__left',{
          y: 100,
          opacity:0
        });
        gsap.timeline({
          scrollTrigger: {
          trigger: '.papel',
          start: "top 80%",
          end: "top 20%",
          scrub:true,
          toggleActions: "play none none reverse",
          }
        }).to('.papel__left', {y:0 ,opacity:1 , duration:0.8, ease: "linear"})

        gsap.set('.papel__center',{
          y: 100,
          opacity:0 
        });
        gsap.timeline({
          scrollTrigger: {
          trigger: '.papel',
          start: "top 80%",
          end: "top 25%",
          scrub:true,
          toggleActions: "play none none reverse",
          }
        }).to('.papel__center', {y:0, opacity:1 , delay:1, duration:0.8, ease: "linear"})

        gsap.set('.papel__right',{
          y: 100,
          opacity:0
        });
        gsap.timeline({
          scrollTrigger: {
          trigger: '.papel',
          start: "top 80%",
          end: "top 25%",
          scrub:true,
          toggleActions: "play none none reverse",
          }
        }).to('.papel__right', {y:0 , opacity:1 ,duration:0.8, delay:2, ease: "linear"})

     

        gsap.set('.posada_img-1',{
            y: 100,
            opacity: 0
          });
          gsap.timeline({
            scrollTrigger: {
            trigger: '.posada',
            start: "top 70%",
            end: "top 40%",
            scrub: true,
            toggleActions: "play none none reverse",
            }
          }).to('.posada_img-1', {y:0, opacity:1, duration:0.8, ease: "linear"})
          

          gsap.set('.posada_img-2',{
            y: 100,
            opacity:0
          });
          gsap.timeline({
            scrollTrigger: {
            trigger: '.posada',
            start: "top 70%",
            end: "top 40%",
            scrub: true,
            toggleActions: "play none none reverse",
            }
          }).to('.posada_img-2', {y:0, opacity:1, duration:0.8, ease: "linear"})
          
          gsap.set('.posada_img-3',{
            scale: 0,
            opacity:0
          });
          gsap.timeline({
            scrollTrigger: {
            trigger: '.posada',
            start: "top 80%",
            end: "top 45%",
            toggleActions: "play none none reverse",
            }
          }).to('.posada_img-3', {scale:1, opacity:1, duration:0.4, ease: "linear"})
          

          gsap.set('.garba_img-1',{
            opacity:0,
            y: 100
          });

          gsap.timeline({
            scrollTrigger: {
            trigger: '.garba',
            start: "top 80%",
            end: "top 50%",
            toggleActions: "play none none reverse",
            }
          }).to('.garba_img-1', { y:0, opacity:1, duration:0.8, ease: "linear"})
          
          gsap.set('.garba_img-2',{
            opacity:0,
            y: 100
          });
          gsap.timeline({
            scrollTrigger: {
            trigger: '.garba',
            start: "top 80%",
            end: "top 50%",

            toggleActions: "play none none reverse",
            }
          }).to('.garba_img-2', { y:0, opacity:1, duration:0.8, ease: "linear"})
          
          
         /* gsap.set('.garba_img-3',{
            y: 100,
            opacity:0,
          });
          gsap.timeline({
            scrollTrigger: {
            trigger: '.garba',
            start: "top 90%",
            end: "top 50%",
            scrub: true,
            toggleActions: "play none none reverse",
            }
          }).to('.garba_img-3', {y:0,opacity:1, duration:0.8, ease: "linear"})

*/
          gsap.set('.box1__doblone',{
            x: 300,
          });

          gsap.timeline({
            scrollTrigger: {
            trigger: '.box1',
            start: `top ${70 + offset}%`,
            end: "top center",
            toggleActions: "play none none reverse",
            }
          }).to('.box1__doblone', {x:0, duration: 1.5, rotation:-360,  ease: "power2.out"})

          gsap.set('.box2',{
            y: 100,
            opacity:0
          });
          gsap.timeline({
            scrollTrigger: {
            trigger: '.box2',
            start: `top ${70 + offset}%`,
       
            toggleActions: "play none none reverse",
            }
          }).to('.box2', {y:0 ,opacity: 1, duration:1, ease: "power2.out"})
  
       gsap.utils.toArray(".cultura__text").forEach(box => {
            gsap.set(box,{
              y: 100,
              opacity:0
            });
            gsap.timeline({
              scrollTrigger: {
              trigger: box,
              start: `top ${70 + offset}%`,
              toggleActions: "play none none reverse",
              }
            }).to(box, {y:0 ,opacity: 1, duration:1, ease: "power2.out"})
        });


      
  
          

}


